import React from 'react';
import NavTagline from '../nav-tagline/nav-tagline';
import Footer from './Footer';


const RequestNotFound = () => (
    <div className="RequestNotFound">
        <NavTagline />
        <main className="layout-container" aria-labelledby="notFoundHeading">
            <div className="container ctr">
                <div className="text-size3 or-clr"><i className="bi bi-cone-striped" aria-hidden="true"></i></div>
                <div className="text-size4" id="notFoundHeading">Sorry, your request was not found.</div>
                <p className="text-size9">The page you are looking for does not exist.
                    If you need immediate support, please call{" "} <a href="tel:18884709913" aria-label="Call support at 1-888-470-9913">
                        1.888.470.9913
                    </a>{" "}
                    or email us at{" "} <a href="mailto: support@secureexsolutions.com" aria-label="Email support at support@secureexsolutions.com">support@secureexsolutions.com</a>.</p>
            </div>
        </main>
        <Footer />
  </div>
);


export default RequestNotFound;
